// Geteiltes, scoped Karten-Design für die Otto-Install-/Uninstall-Dialoge.
// Alles unter `.otto-install` gekapselt — kein globales Klassen-Präfix, kein
// box-sizing-Reset-Leak, keine Kollision mit den geteilten v-*/kl-*-Klassen.
// go-brand-Tokens (#84B933, Outfit/JetBrains Mono — Fonts lädt index.html global).
// Vorlage: Claude-Design-Handoff „Otto App installieren.html".
const STYLE_ID = 'otto-install-styles';

const STYLES = `
.otto-install{--vario-green:#84B933;--vario-green-dark:#6FA028;--vario-green-tint:#EFF6E2;
  --ink:#1A1A1A;--ink-soft:#3A3A3A;--muted:#737373;--surface:#FFFFFF;--border:#E4E4E7;--field:#F1F1F3;
  --success:#22C55E;--danger:#E5484D;--warn:#F5A623;
  font-family:'Outfit',system-ui,sans-serif;color:var(--ink);display:flex;flex-direction:column;}
.otto-install *{box-sizing:border-box;}
.otto-install .mono{font-family:'JetBrains Mono',ui-monospace,monospace;}

.otto-install .apphead{display:flex;align-items:center;gap:14px;margin-bottom:14px;}
.otto-install .brand{display:inline-flex;align-items:center;text-decoration:none;flex:none;}
.otto-install .brand img{height:20px;display:block;}
.otto-install .hdivider{width:1px;height:24px;background:var(--border);flex:none;}
.otto-install .heyebrow{font-size:10.5px;font-weight:600;letter-spacing:.11em;text-transform:uppercase;color:var(--muted);}
.otto-install .htitle h1{font-size:20px;font-weight:600;letter-spacing:-0.01em;margin:0;line-height:1.2;}

.otto-install .stage{display:flex;align-items:flex-start;justify-content:center;padding:24px 16px;}
.otto-install .card{width:100%;max-width:680px;background:var(--surface);border-radius:16px;
  box-shadow:0 1px 2px rgba(16,24,40,.04),0 18px 44px -20px rgba(16,24,40,.22);overflow:hidden;}
.otto-install .card-top{padding:26px 30px;border-bottom:1px solid #F0F0F1;display:flex;align-items:center;gap:18px;}
.otto-install .otto-badge{height:38px;flex:none;}
.otto-install .card-top .titles{flex:1;min-width:0;}
.otto-install .card-top h2{font-size:21px;font-weight:700;letter-spacing:-0.015em;margin:0;}
.otto-install .card-top .sub{font-size:13px;color:var(--muted);margin-top:3px;}
.otto-install .env-tag{flex:none;display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:600;border-radius:999px;padding:4px 11px;background:#FDF1DC;color:#9A6A12;}
.otto-install .env-tag .d{width:6px;height:6px;border-radius:50%;background:var(--warn);}
.otto-install .env-tag.prod{background:var(--vario-green-tint);color:var(--vario-green-dark);}
.otto-install .env-tag.prod .d{background:var(--vario-green);}

.otto-install .card-body{padding:24px 30px;}
.otto-install .intro{font-size:14px;color:var(--ink-soft);line-height:1.6;margin:0 0 22px;}
.otto-install .intro a{color:var(--vario-green-dark);font-weight:500;text-decoration:none;border-bottom:1px solid rgba(111,160,40,.35);}
.otto-install .intro a:hover{border-bottom-color:var(--vario-green-dark);}

.otto-install .sec-lab{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#9aa0a6;margin:0 0 14px;display:flex;align-items:center;gap:9px;}
.otto-install .sec-lab::after{content:"";flex:1;height:1px;background:#F0F0F1;}

.otto-install .field{display:flex;flex-direction:column;gap:6px;margin-bottom:16px;}
.otto-install .field label{font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:var(--muted);display:flex;align-items:center;gap:7px;}
.otto-install .field .req{color:var(--danger);}
.otto-install .inp,.otto-install .sel{font-family:inherit;font-size:14px;color:var(--ink);background:#fff;border:1px solid #E2E2E6;border-radius:9px;height:44px;padding:0 13px;width:100%;transition:border-color .15s,box-shadow .15s;}
.otto-install .inp::placeholder{color:#a8acb2;}
.otto-install .inp:focus,.otto-install .sel:focus{outline:none;border-color:var(--vario-green);box-shadow:0 0 0 3px rgba(132,185,51,.14);}
.otto-install .inp.mono{font-family:'JetBrains Mono',monospace;font-size:13px;letter-spacing:.02em;}
.otto-install .pwwrap{position:relative;}
.otto-install .pwwrap .inp{padding-right:42px;}
.otto-install .pweye{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:26px;height:26px;border:none;background:none;cursor:pointer;color:#9aa0a6;display:flex;align-items:center;justify-content:center;}
.otto-install .pweye:hover{color:var(--ink-soft);}
.otto-install .pweye svg{width:17px;height:17px;}
.otto-install .selwrap{position:relative;}
.otto-install .selwrap .sel{appearance:none;-webkit-appearance:none;cursor:pointer;padding-right:38px;}
.otto-install .selwrap::after{content:"";position:absolute;right:15px;top:50%;width:8px;height:8px;border-right:2px solid #9aa0a6;border-bottom:2px solid #9aa0a6;transform:translateY(-65%) rotate(45deg);pointer-events:none;}
.otto-install .hint{font-size:11.5px;color:#9aa0a6;}

.otto-install .card-foot{padding:18px 30px;border-top:1px solid #F0F0F1;display:flex;align-items:center;gap:12px;flex-wrap:wrap;}
.otto-install .foot-status{font-size:12.5px;color:var(--muted);display:flex;align-items:center;gap:8px;}
.otto-install .foot-status svg{width:15px;height:15px;color:#c4c8ce;flex:none;}
.otto-install .foot-status.ready{color:var(--vario-green-dark);}
.otto-install .foot-status.ready svg{color:var(--vario-green);}
.otto-install .foot-status.error{color:var(--danger);}
.otto-install .foot-status.error svg{color:var(--danger);}
.otto-install .foot-actions{margin-left:auto;display:flex;gap:11px;}

.otto-install .btn{font-family:inherit;font-size:13.5px;font-weight:500;border-radius:9px;padding:11px 18px;border:1px solid transparent;cursor:pointer;display:inline-flex;align-items:center;gap:9px;line-height:1;white-space:nowrap;transition:background .2s,box-shadow .2s,border-color .2s;}
.otto-install .btn svg{width:16px;height:16px;}
.otto-install .btn-primary{background:var(--vario-green);color:#fff;box-shadow:0 2px 8px -2px rgba(132,185,51,.5);}
.otto-install .btn-primary:hover:not(:disabled){background:var(--vario-green-dark);box-shadow:0 4px 14px -3px rgba(132,185,51,.55);}
.otto-install .btn-ghost{background:#fff;color:var(--ink-soft);border-color:#E2E2E6;}
.otto-install .btn-ghost:hover:not(:disabled){background:#fafafa;border-color:#d2d2d6;}
.otto-install .btn-danger{background:var(--danger);color:#fff;box-shadow:0 2px 8px -2px rgba(229,72,77,.45);}
.otto-install .btn-danger:hover:not(:disabled){background:#cf3b40;}
.otto-install .btn:disabled{opacity:.5;cursor:not-allowed;box-shadow:none;}
/* "pending" = optisch gedimmt, aber KLICKBAR (Klick validiert dann selbst). Bewusst
   kein disabled-Attribut: 1Password/Autofill befüllt Felder ohne input-Event, ein
   disabled-Button würde den Klick hart verschlucken. */
.otto-install .btn.is-pending{opacity:.55;box-shadow:none;}
.otto-install .btn .spin{width:15px;height:15px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:otto-spin .7s linear infinite;}
@keyframes otto-spin{to{transform:rotate(360deg);}}

.otto-install .done-card{text-align:center;padding:48px 30px 40px;}
.otto-install .done-ic{width:64px;height:64px;border-radius:50%;background:var(--vario-green-tint);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;}
.otto-install .done-ic svg{width:30px;height:30px;color:var(--vario-green-dark);}
.otto-install .done-ic.busy{background:var(--field);}
.otto-install .done-ic.neutral{background:var(--field);}
.otto-install .done-ic.neutral svg{color:var(--muted);}
.otto-install .done-ic.error{background:#FDECEC;}
.otto-install .done-ic.error svg{color:var(--danger);}
.otto-install .big-spin{width:30px;height:30px;border:3px solid #E2E2E6;border-top-color:var(--vario-green);border-radius:50%;animation:otto-spin .7s linear infinite;}
.otto-install .done-card h2{font-size:21px;font-weight:700;margin:0 0 8px;}
.otto-install .done-card p{font-size:14px;color:var(--muted);margin:0 auto 22px;max-width:400px;line-height:1.6;}
.otto-install .done-card .mono{font-size:12.5px;color:var(--ink-soft);}

/* Auto-Grow für die Install-/Uninstall-Dialoge (Marker html.otto-autogrow, gesetzt von der
   jeweiligen render*-Funktion). Ohne das deckelt bridge.css §16 (html,body,main#app =
   height:100% + overflow:hidden) body.scrollHeight auf die Viewport-Höhe → das iframe meldet
   Vario nur die Viewport- statt der Inhaltshöhe und die Karte (inkl. Foot-Buttons) wird unten
   abgeschnitten. Höher-spezifischer Selektor gewinnt gegen die nackten bridge-Regeln, ohne die
   geteilte bridge.css zu ändern. Identisch zu otto-settings/listing-status. */
html.otto-autogrow, html.otto-autogrow body, html.otto-autogrow main#app{height:auto;overflow:visible;}
html.otto-autogrow main#app > section#content{flex:0 0 auto;}
`;

// Inline-SVGs aus dem Design-Handoff (stroke-basiert, currentColor).
export const OTTO_ICON = {
  eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>',
  info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/></svg>',
  check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>',
  checkBold:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>',
  x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  xBold:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  download:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v12M7 10l5 5 5-5M5 21h14"/></svg>',
  trash:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>',
};

/** Injiziert die scoped `.otto-install`-Styles einmalig in den <head>. */
export function ensureOttoStyles(): void {
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = STYLES;
  document.head.appendChild(el);
}

/** Markup des App-Headers (Logo + Eyebrow + Titel). */
export function ottoAppHead(eyebrow: string, title: string): string {
  return `
    <header class="apphead">
      <a class="brand" href="https://www.go-ecommerce.de" target="_blank" rel="noopener" title="go eCommerce"><img src="/logo-black.png" alt="go eCommerce"></a>
      <span class="hdivider"></span>
      <div class="htitle"><div class="heyebrow">${eyebrow}</div><h1>${title}</h1></div>
    </header>`;
}

export function ottoEscapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
